/**
 * Transforms API drug interaction response into UI InteractionItem[].
 * Order: high first, then moderate, then minor.
 */

import type { DrugInteractionResponse, InteractionItem } from "./types";

export function drugInteractionResponseToInteractionItems(
  response: DrugInteractionResponse | null | undefined
): InteractionItem[] {
  if (!response) return [];

  const high =
    response.high_severity_descriptions?.map((item, index) => ({
      id: `high-${index}`,
      description: item.description ?? "",
      severityLevel: "High",
      type: "drug" as const,
      drugA: item.drug_a ?? (item as { drugA?: string }).drugA,
      drugB: item.drug_b ?? (item as { drugB?: string }).drugB,
    })) ?? [];
  const moderate =
    response.moderate_severity_descriptions?.map((item, index) => ({
      id: `moderate-${index}`,
      description: item.description,
      severityLevel: "Moderate",
      type: "drug" as const,
    })) ?? [];
  const minor =
    response.minor_severity_descriptions?.map((item, index) => ({
      id: `minor-${index}`,
      description: item.description,
      severityLevel: "Minor",
      type: "drug" as const,
    })) ?? [];

  return [...high, ...moderate, ...minor];
}
